const RECORD_STATUS = {
  RECEIVED: 'RECEIVED',
  APPROVED: 'APPROVED',
};

export { RECORD_STATUS };

export default RECORD_STATUS;
